import { createActions } from "reduxsauce";

export const { Types, Creators } = createActions(
  {
    languageChange: ["language"],
  },
  {}
);
